import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import DiscountIcon from '@wix/da-ds/pkg/Icons/16x16/Discount';
import DiscountsPopup from '../DiscountsPopup';
import s from './DiscountsPopupTrigger.scss';
const DiscountsPopupTrigger = ({ className, allDiscounts = [], eligibleDiscount })=>{
    const [showDiscountsPopup, setShowDiscountsPopup] = useState(false);
    const { t } = useTranslation();
    const sellerDiscounts = useFlag('seller_discounts');
    if (!sellerDiscounts) {
        return null;
    }
    // Don't show if there are no discounts
    if (!(allDiscounts === null || allDiscounts === void 0 ? void 0 : allDiscounts.length)) {
        return null;
    }
    // Don't show if user has eligible discount(s) AND there's only 1 total discount
    // (nothing else for them to see)
    if (eligibleDiscount && allDiscounts.length === 1) {
        return null;
    }
    const hasEligibleDiscount = eligibleDiscount !== undefined;
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className)
    }, /*#__PURE__*/ React.createElement(TextButton, {
        key: "save",
        size: "medium",
        variant: "main",
        priority: "secondary",
        className: s['btn-show-discounts'],
        onClick: ()=>setShowDiscountsPopup(true),
        icon: hasEligibleDiscount ? undefined : DiscountIcon,
        iconClassName: s['icon-discount']
    }, hasEligibleDiscount ? t('popup.discounts.trigger.viewAll') : t('popup.discounts.trigger.viewAvailable')), /*#__PURE__*/ React.createElement(DiscountsPopup, {
        isOpen: showDiscountsPopup,
        onRequestClose: ()=>setShowDiscountsPopup(false),
        discounts: allDiscounts
    }));
};
DiscountsPopupTrigger.displayName = 'DiscountsPopupTrigger';
export default DiscountsPopupTrigger;

//# sourceMappingURL=DiscountsPopupTrigger.js.map